export default __webpack_public_path__ + "static/media/banner2.1a002dcb.webp";